module.exports = __webpack_public_path__ + "img/18.56d77f5f.png";